import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { API } from "../../constants";
import useCompanyStore from "../../hooks/useCompanyStore";

const MovieList = () => {
  const [movieScreen, setMovieScreen] = useState([]);
  const { companyId } = useCompanyStore();
  const fetchMovieScreen = async () => {
    try {
      const response = await fetch(API.LIST_MOVIE_SCREEN + "/" + companyId, {
        method: "GET",
      });

      const result = await response.json();

      if (!response.ok || result.status === false) {
        setMovieScreen([]);
        return;
      }

      setMovieScreen(result.data || []);
    } catch (error) {

      setMovieScreen([]);
    }
  };

  useEffect(() => {
    if (!companyId) return;
    fetchMovieScreen();
  }, [companyId]);



  const movies = useMemo(() => {
    const allMovies = [];

    movieScreen.forEach((screen) => {
      const screenMovies = screen.movies || [];

      screenMovies.forEach((movie) => {
        allMovies.push({
          id: movie._id,
          showtimeId: movie.showtimeId || movie._id,
          title: movie.nowShowing || movie.movie_title || "Untitled Movie",
          image: movie.poster_image || "../assets/images/no-image.jpg",
          rating: movie.rating || "",
          genre: movie.genre || "",
          suitability_label: movie.suitability_label,
          language: movie.language || "",
          duration: movie.duration || "",
          description: movie.description || "",
          adult_ticket_price: Number(movie.adult_ticket_price || 0),
          child_ticket_price: Number(movie.child_ticket_price || 0),
          screen: screen.screenName || "",
          screenId: screen.screenId || "",
          time: movie.showtime || movie.start_time || "",
          showtimes: movie.showtimes || movie.startTimes || [],
          rawMovie: movie,
          rawScreen: screen,
        });
      });
    });

    return allMovies;
  }, [movieScreen]);

  return (
    <section className="movie-section movie-list-section">
      <div className="container">
        <div className="section-heading">
          <span>Now Showing</span>

          <h2>Movie List</h2>

          <p>Book your favorite movies and enjoy them on the big screen.</p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={4}
          loop={movies.length > 4}
          speed={1000}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        >
          {movies.map((movie) => (
            <SwiperSlide key={`${movie.screenId}-${movie.id}-${movie.time}`}>
              <div className="movie-card">
                <div className="movie-img">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    onError={(e) => {
                      e.currentTarget.src = "../assets/images/no-image.jpg";
                    }}
                  />

                  <span>
                    <i className="fa-solid fa-star"></i>
                    {movie.rating || "N/A"}
                  </span>
                </div>

                <div className="movie-content">
                  <h3>{movie.title}</h3>

                  <p className="movie-genre">
                    <i className="fa-solid fa-film"></i>
                    {movie.genre}
                  </p>

                  <p className="movie-theater">
                    <i className="fa-solid fa-circle-info"></i>
                    {movie.suitability_label}
                  </p>

                  <div className="movie-meta-list">
                    <span>
                      <i className="fa-solid fa-tv"></i>
                      {movie.screen}
                    </span>

                    <span>
                      <i className="fa-solid fa-clock"></i>
                      {movie.time || "Time N/A"}
                    </span>
                  </div>

                  <Link
                    to={`/screens/${movie.id}`}
                    state={{
                      movie,
                      screen: movie.rawScreen,
                      selectedTime: movie.time,
                    }}
                    className="movie-book-btn"
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default MovieList;